// extracted by mini-css-extract-plugin
export default {"screenshotWrapper":"screenshot_screenshotWrapper__-Pphp","nameAndTime":"screenshot_nameAndTime__EaSgy","screenshot":"screenshot_screenshot__HPhmf"};